import { Wallet } from "lucide-react";
import { Card } from "@/components/ui/card";

const fmtBRL = (v) =>
  Number(v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const TYPE_LABEL = {
  checking: "Corrente",
  savings: "Poupança",
  credit_card: "Cartão",
  investment: "Investimento",
  cash: "Dinheiro",
  digital: "Digital",
};

export default function BalanceOverviewCard({ data }) {
  const accounts = data?.accounts || [];
  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-9 h-9 rounded-lg bg-indigo-500/10 flex items-center justify-center">
          <Wallet className="w-4 h-4 text-indigo-400" />
        </div>
        <div>
          <div className="text-xs text-foreground-muted">Saldo total</div>
          <div className="text-2xl font-bold text-foreground">
            {fmtBRL(data?.total_balance)}
          </div>
        </div>
      </div>

      {accounts.length > 0 ? (
        <div className="space-y-2">
          {accounts.map((a) => (
            <div
              key={`${a.name}-${a.institution}`}
              className="flex items-center justify-between py-2 px-3 rounded-lg bg-surface-card-hover"
            >
              <div className="min-w-0 mr-2">
                <div className="text-sm text-foreground font-medium truncate">{a.name}</div>
                <div className="text-[10px] text-foreground-muted">
                  {TYPE_LABEL[a.type] || a.type}
                  {a.institution ? ` · ${a.institution}` : ""}
                </div>
              </div>
              <div className="text-sm font-semibold text-foreground whitespace-nowrap">
                {fmtBRL(a.balance)}
              </div>
            </div>
          ))}
          {data?.accounts_count > accounts.length && (
            <div className="text-[10px] text-foreground-muted text-center pt-1">
              + {data.accounts_count - accounts.length} {data.accounts_count - accounts.length === 1 ? "conta" : "contas"}
            </div>
          )}
        </div>
      ) : (
        <div className="text-xs text-foreground-muted py-4 text-center">
          Nenhuma conta cadastrada ainda.
        </div>
      )}
    </Card>
  );
}
